import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {ButtonBehavior} from './button-behavior.js';
import {Puzzle} from './puzzle.js';
import {Coroutine} from '../classes/coroutines/Coroutine.js';

export class BombButtonTutorial extends ButtonBehavior {
    static TypeName = 'bomb-button-tutorial';
    static InheritProperties = true;

    private static _instance: BombButtonTutorial;

    static get instance(): BombButtonTutorial {
        return BombButtonTutorial._instance;
    }
    pieceToSpawn: string = 'Coconut Bomb';
    enabled: boolean;

    init() {
        if (BombButtonTutorial._instance) {
            console.error('There can only be one instance of BombButtonTutorial Component');
        }
        BombButtonTutorial._instance = this;
    }

    override start() {
        //super.start();
        this.myInventoryDisplayColor = [0.25, 0.25, 0.25, 1];
        this.myInventoryDisplayText = '1';

        this.lastTurn = 0;
        this.enabled = false;
        // turn on mask
        this.sliderValue = 0.5;

        this.currentCooldown = this.turnCooldown;

        this.isInactive = true;
        this.updateMaterial();
        this.notifyPropertyChanged('everything');
    }

    override onClick(): void {
        if (!this.enabled) {
            return;
        }
        this.myInventoryDisplayColor = [0.25, 0.25, 0.25, 1];
        this.myInventoryDisplayText = '0';

        this.buttonAction();

        this.isInactive = true;
        this.enabled = false;

        // turn on mask
        this.sliderValue = 1;

        this.lastTurn = 0;
        this.updateMaterial();
        this.notifyPropertyChanged('everything');
    }

    override buttonAction() {
        if (!this.enabled) {
            return;
        }
        Puzzle.instance.spawner.queuePiece(this.pieceToSpawn);
    }

    completeTurn() {
        this.lastTurn++;

        if (this.lastTurn >= this.currentCooldown) {
            this.myInventoryDisplayColor = [1, 1, 1, 1];
            let currentSlider = this.sliderValue;
            this._coroutineManager.stopCoroutine(this._adjustLevelSliderDynamicallyId);
            this._adjustLevelSliderDynamicallyId = this._coroutineManager.addCoroutine(
                new Coroutine(this._adjustLevelSliderDynamically(0.1, currentSlider))
            );

            this.isInactive = false;
            this.updateMaterial();
            this.notifyPropertyChanged('everything');
            // 	foreach (PlaySoundOnClick obj in buttonClickSFX)
            // 	{
            // 		obj.enabled = true;
            // 	}

            // 	buttonScale.enabled = true;
        } else {
            let currentSlider = this.sliderValue;
            let percent = 1.0 - this.lastTurn / this.currentCooldown;

            this._coroutineManager.stopCoroutine(this._adjustLevelSliderDynamicallyId);
            this._adjustLevelSliderDynamicallyId = this._coroutineManager.addCoroutine(
                new Coroutine(this._adjustLevelSliderDynamically(percent, currentSlider))
            );
        }
    }

    override newGame = (puzzle: Puzzle) => {
        this.myInventoryDisplayColor = [0.25, 0.25, 0.25, 1];
        this.myInventoryDisplayText = '1';

        this.lastTurn = 0;
        this.enabled = false;
        // turn on mask
        this.sliderValue = 1;

        this.currentCooldown = this.turnCooldown;

        this.isInactive = true;
        this.updateMaterial();
        this.notifyPropertyChanged('everything');
    };

    override turnsCompleted = (puzzle: Puzzle) => {};
    override notifyStatsChanged() {}
}
